import React from 'react';

import { Autocomplete as DPCAutocomplete } from 'e100-react-components';

import { IPropTypes as AutocompletePropTypes } from 'e100-react-components/lib/components/Autocomplete/types/props';

import { useIntl } from 'react-intl';
import { useStyles } from './styles';

export const Autocomplete = (props: AutocompleteProps) => {
  const classes = useStyles();
  const { formatMessage } = useIntl();

  return (
    <DPCAutocomplete
      getOptionLabel={(item: any) => item?.value}
      classes={{
        input: classes.input,
        inputRoot: classes.inputRoot,
        popupIndicator: classes.popupIndicator,
        focused: classes.focused,
        clearIndicator: classes.clearIndicator,
        paper: classes.paper,
        popper: classes.popper
      }}
      noOptionsText={`${formatMessage({ id: 'noData' })}...`}
      loadingText={`${formatMessage({ id: 'loading' })}...`}
      filterOptions={item => item}
      renderOption={({ value }: any) => value}
      {...props}
    />
  );
};

export interface AutocompleteProps extends AutocompletePropTypes {}
